// i18n area 'auth' — locale pt-PT (pt-PT, task #171, onda 1): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/auth.pt-PT.meta.json.
import type { enUS } from './auth'

export const ptPT: typeof enUS = {
  login: {
    welcome: 'Trantor TVirt v6',
    subtitle: 'Inicie sessão na sua conta',
    username: 'Nome de utilizador',
    usernamePlaceholder: 'Introduza o nome de utilizador',
    usernameHint: 'Use utilizador@domínio para se autenticar num realm de diretório',
    continue: 'Continuar',
    changeUser: 'Não é você?',
    password: 'Palavra-passe',
    forgotPassword: 'Esqueceu a palavra-passe?',
    submit: 'Entrar',
    otp: 'Código de uso único',
    otpSubtitle: 'Introduza o código do seu autenticador',
    otpHint: 'Seis dígitos da app de autenticação, ou um dos códigos de recuperação',
    otpSubmit: 'Verificar',
    invalidCredentials: 'Nome de utilizador ou palavra-passe inválidos',
    tooManyAttempts: 'Demasiadas tentativas — aguarde um momento e tente novamente',
    realmUnavailable: 'O realm não pode verificar as credenciais neste momento — o store do cluster não está acessível. Inicie sessão como utilizador local (break-glass).',
    genericError: 'Não foi possível iniciar sessão — o backend TVirt está acessível?'
  },
  user: {
    logout: 'Sair',
    password: {
      menu: 'Alterar palavra-passe',
      title: 'Altere a sua palavra-passe',
      current: 'Palavra-passe atual',
      new: 'Nova palavra-passe',
      confirm: 'Confirmar nova palavra-passe',
      mismatch: 'As palavras-passe não coincidem',
      error: 'Não foi possível alterar a palavra-passe',
      forcedTitle: 'Altere a palavra-passe para continuar',
      forcedHint: 'Esta palavra-passe foi definida por um administrador e tem de ser substituída antes de entrar.',
      forcedSubmit: 'Alterar e entrar'
    },
    mfa: {
      title: 'Autenticação de dois fatores',
      subtitle: 'Um segundo fator pedido a cada início de sessão',
      loadError: 'Não foi possível carregar o estado do segundo fator',
      enrolled: 'Ativo',
      notEnrolled: 'Não ativo',
      enrolledAt: 'Ativado em',
      codesRemaining: 'Códigos de recuperação restantes',
      requiredHint: 'Um administrador exige o segundo fator nesta conta: configure-o agora — enquanto não o fizer pode iniciar sessão, mas pouco mais.',
      enroll: 'Configurar',
      enrollTitle: 'Configurar a autenticação de dois fatores',
      enrollHint: 'Leia este código com a app de autenticação, depois digite o código que ela mostra para confirmar.',
      secretHint: 'Não consegue lê-lo? Digite este segredo na app:',
      code: 'Código da app',
      confirm: 'Confirmar',
      startError: 'Não foi possível iniciar a configuração',
      confirmError: 'Não foi possível confirmar a configuração',
      codesTitle: 'Os seus códigos de recuperação',
      codesWarning: 'Estes códigos são mostrados uma única vez. Guarde-os agora: cada um permite-lhe entrar quando o autenticador não está disponível, e vale uma única vez.',
      codesAck: 'Guardei os códigos de recuperação',
      codesDone: 'Concluído',
      copy: 'Copiar',
      copied: 'Copiado',
      download: 'Transferir',
      regenerate: 'Novos códigos de recuperação',
      regenerateTitle: 'Regenerar os códigos de recuperação',
      regenerateHint: 'Todos os códigos emitidos até agora deixam de funcionar no momento em que o novo conjunto é gerado.',
      regenerateConfirm: 'Regenerar',
      regenerateError: 'Não foi possível regenerar os códigos de recuperação',
      remove: 'Remover',
      removeTitle: 'Remover o segundo fator',
      removeConfirm: 'Remover',
      removeHint: 'A conta volta a ter apenas a palavra-passe. Pode voltar a configurar o segundo fator quando quiser.',
      removeRequiredHint: 'Um administrador exige o segundo fator nesta conta, por isso o servidor recusará a remoção — peça primeiro que levantem a obrigação.',
      removeError: 'Não foi possível remover o segundo fator'
    },
    profile: {
      menu: 'Ir para o meu perfil',
      sessions: 'Sessões ativas',
      sessionsHint: 'As suas sessões abertas neste nó',
      sessionsEmpty: 'Nenhuma sessão ativa',
      sessionCreated: 'Sessão iniciada',
      sessionExpires: 'Expira',
      revoke: 'Revogar sessão',
      revokeError: 'Não foi possível revogar a sessão',
      loadError: 'Não foi possível carregar as sessões'
    }
  }
}
